import { RouteConfig } from 'vue-router'
const SparkMarathonIndex = () => import('../activity/202408/spark-marathon/Index.vue')
const SparkMarathonRank = () => import('../activity/202408/spark-marathon/RankListPage.vue')
const SparkMarathonRecord = () => import('../activity/202408/spark-marathon/RecordPage.vue')
const SparkMarathonRule = () => import('../activity/202408/spark-marathon/RulePage.vue')
const SparkMarathonReward = () => import('../activity/202408/spark-marathon/RewardPage.vue')

export const A202408SparkMarathonIndex: RouteConfig = {
  path: '/activity/202408/spark-marathon/index',
  name: 'activity_202408_spark_marathon_index',
  component: SparkMarathonIndex,
  meta: {
    title: '火花马拉松',
    expiryDate: '2024-12-30',
  },
  props: (route) => ({ ...route.query }),
}

export const A202408SparkMarathonRank: RouteConfig = {
  path: '/activity/202408/spark-marathon/rank',
  name: 'activity_202408_spark_marathon_rank',
  component: SparkMarathonRank,
  meta: {
    title: '火花马拉松贡献榜',
    expiryDate: '2024-12-30',
  },
  props: (route) => ({ ...route.query }),
}

export const A202408SparkMarathonRecord: RouteConfig = {
  path: '/activity/202408/spark-marathon/record',
  name: 'activity_202408_spark_marathon_record',
  component: SparkMarathonRecord,
  meta: {
    title: '火花马拉松领取记录',
    expiryDate: '2024-12-30',
  },
  props: (route) => ({ ...route.query }),
}

export const A202408SparkMarathonRule: RouteConfig = {
  path: '/activity/202408/spark-marathon/rule',
  name: 'activity_202408_spark_marathon_rule',
  component: SparkMarathonRule,
  meta: {
    title: '火花马拉松规则',
    expiryDate: '2024-12-30',
  },
  props: (route) => ({ ...route.query }),
}

export const A202408SparkMarathonReward: RouteConfig = {
  path: '/activity/202408/spark-marathon/reward',
  name: 'activity_202408_spark_marathon_reward',
  component: SparkMarathonReward,
  meta: {
    title: '火花马拉松贡活动奖励',
    expiryDate: '2024-12-30',
  },
  props: (route) => ({ ...route.query }),
}
export default [
  A202408SparkMarathonIndex,
  A202408SparkMarathonRank,
  A202408SparkMarathonRecord,
  A202408SparkMarathonRule,
  A202408SparkMarathonReward,
]
